module.exports = __webpack_public_path__ + "img/arrow-right.b1bc912b.svg";